import React from 'react'
import { Formik } from 'formik'
import { Form, Spacer, View } from 'oio-react'
import PropTypes from 'prop-types'
import CloseIcon from 'assets/icons/close'
import FormView from 'src/sites/kits/UI/Form/View'

const FormBuilderPreview = ({ elements, onCloseButtonClick, subtitle, title }) => (
   <View
      width="100%"
      height="100%"
      padding="24px"
      scroll="on">
      <div className="flex items-start justify-between">
         <div>
            <div className="text-lg font-semibold tracking-tight">{title}</div>
            <div className="relative -top-1 text-base text-neutral-500">{subtitle}</div>
         </div>
         <button type="button" className="hover:opacity-70 cursor-pointer relative left-1" onClick={onCloseButtonClick}>
            <CloseIcon width="20px" height="20px" />
         </button>
      </div>
      <Spacer size="2" />
      <Formik render={() => (
         <Form
            elementAppearance="plain"
            elementBackgroundColor="#eee"
            elementFocusBackgroundColor="#f3f3f3">
            <FormView elements={elements} />
         </Form>
      )}
      />
   </View>
)

FormBuilderPreview.propTypes = {
   elements: PropTypes.array.isRequired,
   onCloseButtonClick: PropTypes.func.isRequired,
   subtitle: PropTypes.string.isRequired,
   title: PropTypes.string.isRequired
}

export default FormBuilderPreview
